import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Claim.UpdateClaimPayeeInfo.IRequest;
type Response = Api.Core.Claim.UpdateClaimPayeeInfo.IResponse;
type Headers = Api.Core.Claim.UpdateClaimPayeeInfo.IHeaders;
const url = '/api/Claims/Claim/UpdateClaimPayeeInfo';
export default async function claimUpdateClaimPayeeInfoApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
